import "./App.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { agentCategories } from "./agentsPageBuilder";
import Nav from "./components/nav/nav";
import AgentCard from "./card/agent-card";
//@ts-ignore
import { PostHogProvider } from "posthog-js/react";
import ReactGA from "react-ga4";
import AdminPanel from "./admin-panel/admin-panel";
import Categories from "./categories/categories";
import RenderPage from "./renderPage";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SubCategories from "./sub-categories";
import RenderPageCard from "./test/RenderPageCard";
import RenderAgentCards from "./test/RenderAgentCard";
import PageCard from "./test-2/PageCard";
import PageCard2 from "./test-2/PageCard2";
//@ts-ignore
import { newAgentCategories } from "./test-2/utils/newPageBuilder";
import SompoFinal from "./components/temp-components/sompo-final";
import axios from "axios";
import CFAPage from "./test-2/temp-demo-components/CFA/CfaPage";
import NotFound from "./components/not-found/not-found";
import ThablPage from "./test-2/temp-demo-components/THABL/thablPage";
import TSCPage from "./test-2/temp-demo-components/TSC/TscPage";
import { agentCategoriesUs } from "./agentsPageBuilder-US";
import Categories2 from "./categories/categories2"
import PushToHome from "./categories/PushToHome";
import NurixExperienceApp from "./nurix-experience/NurixExperienceApp";
// import ChatWidgetLoader from "./test-2/temp-demo-components/THABL/components/ChatWidgetLoader";
if (process.env.NODE_ENV === "production") ReactGA.initialize("G-1K4C30KRNE");

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST
};

const region = process.env.REACT_APP_DEPLOYED_REGION;

const queryClient = new QueryClient();

const AppContent = () => {
  const location = useLocation();

  type CategoryKey = "Default" | "Starbucks" | "Travel" | "Hospitality" | "Retail";

  interface Page {
    page_id: string;
    page_path: string;
    page_title: string;
    page_description: string;
    page_category: string;
    page_logo: string | null;
  }

  const [pageData, setPageData] = useState<Page[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchAgents = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/public/experience/pages/`
      );
      setPageData(response.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  useEffect(() => {
    const widget = document.getElementById('nurix-widget');
    if (widget) {
      const allowedPaths = ['/nurix/new/nurix-secure'];
      const shouldShow = allowedPaths.includes(location.pathname);


      widget.classList.toggle('hidden', !shouldShow);
    }
  }, [location.pathname]);

  const renderAgentCards = (categoryKey: CategoryKey) => {
    const categoryInfo =
      //@ts-ignore
      region === "prod-india" ? agentCategories[categoryKey] : agentCategoriesUs[categoryKey];

    return (
      <div className="agent-cards-row" key={categoryKey}>
        {categoryInfo.agents.map((agent: any) => (
          <AgentCard key={agent.id} {...agent} categoryKey={categoryKey} />
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center">
          <div className="flex space-x-2 mb-4">
            <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></span>
            <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></span>
            <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></span>
          </div>
          <p className="text-xl font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <section className="nurix-section overflow-x-hidden">
      {(location.pathname !== "/real-estate" &&
        location.pathname !== "/nurix/unifi" &&
        location.pathname !== "/nurix/hoabl2" &&
        location.pathname !== "/nurix/thabl") && <Nav />}

      {/* <ChatWidgetLoader /> */}
      <div className="container pb-32 md:pb-0">
        <div className="overlay-content">
          <Routes>
            {Object.entries(region === "prod-india" ? agentCategories : agentCategoriesUs).map(
              ([key, category]) => (
                <Route
                  key={key}
                  path={category.path}
                  element={
                    <RenderPage title={category.pageTitle} path={category.path}>
                      {renderAgentCards(key as CategoryKey)}
                    </RenderPage>
                  }
                />
              )
            )},

            <Route
              path="/"
              element={
                  <Categories />
              }
            />
            <Route 
              path = "/categories"
              element = {
                <PushToHome />
              }
            />
            <Route
              path="/agents"
              element={
                  <Categories2 />
              }
            />

            {Object.entries(newAgentCategories).map(([key, item]) =>
              item.path === "chick-fil-a" ||
              item.path === "chick-fil-a-demo" ||
              item.path === "cfa-order-taking" ||
              item.path === "cfa-customer-representative" ||
              item.path === "cfa-operations" ? (
              <Route
                key={key}
                path={`nurix/${item.path}`}
                element={
                <CFAPage
                  page_path={item.path}
                  page_title={item.pageTitle}
                  page_category={item.pageCategory || ""}
                />
                }
              />
              ) : item.path === "thabl" || item.path === "xanadu" ? (
              <Route
                key={key}
                path={`nurix/${item.path}`}
                element={<NotFound />}
              />
              ) : item.path === "tractor-supply-co" ? (
              <Route
                key={key}
                path={`nurix/${item.path}`}
                element={
                <TSCPage
                  page_path={item.path}
                  page_title={item.pageTitle}
                  page_category={item.pageCategory || ""}
                />
                }
              />
              ) : item.path === "hoabl2" ? (
              <Route
                key={key}
                path={`nurix/${item.path}`}
                element={
                <ThablPage
                  page_path={item.path}
                  page_title={item.pageTitle}
                  page_category={item.pageCategory || ""}
                />
                }
              />
              ) : (
              <Route
                key={key}
                path={`nurix/${item.path}`}
                element={
                <PageCard
                  page_path={item.path}
                  page_title={item.pageTitle}
                  page_category={item.pageCategory}
                />
                }
              />
              )
            )}

            {pageData.map((item, key) => {
              if (item.page_path === "real-estate") {
                return (
                  <Route
                    key={key}
                    path={`${item.page_path}`}
                    element={
                      <PageCard2
                        page_id={item.page_id}
                        page_path={item.page_path}
                        page_title={item.page_title}
                        page_category={item.page_category || ""}
                        page_logo={item.page_logo ? parseInt(item.page_logo) : 0}
                      />
                    }
                  />
                );
              } else {
                return (
                  <Route
                    key={key}
                    path={`nurix/new/${item.page_path}`}
                    element={
                      <PageCard2
                        page_id={item.page_id}
                        page_path={item.page_path}
                        page_title={item.page_title}
                        page_category={item.page_category || ""}
                        page_logo={item.page_logo ? parseInt(item.page_logo) : 0}
                      />
                    }
                  />
                );
              }
            })}

            <Route
              path="/insurance-sub-categories"
              element={
                <RenderPage title="Select your use case" path="/insurance-sub-categories">
                  <SubCategories />
                </RenderPage>
              }
            />

            <Route path="/sompo-final" element={<SompoFinal />} />
          </Routes>
        </div>
      </div>
    </section>
  );
};


const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <PostHogProvider
          apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
          options={options}
        >
          {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string} > */}
            <Routes>
              <Route path="/nurix-experience/*" element={<NurixExperienceApp />} />
              <Route path="/admin/nurixai" element={<AdminPanel />} />
              <Route path="/*" element={<AppContent />} />
              {/* <Route path="/test" element={<Play />} /> */}
              {/* <Route path ="*" element={<NotFound/>}/> */}
            </Routes>
          {/* </GoogleReCaptchaProvider> */}
        </PostHogProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
